import { render, staticRenderFns } from "./CambioBobina.vue?vue&type=template&id=96b73744&scoped=true&"
import script from "./CambioBobina.vue?vue&type=script&lang=js&"
export * from "./CambioBobina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b73744",
  null
  
)

export default component.exports